import { Wrench, Package, Route, MapPin, Sprout, Crosshair, GraduationCap } from "lucide-react";
import { PORQUE, IMG } from "@/data/content";
import { Reveal, SectionTag, TituloLineas } from "@/components/Reveal";
import { useCertero } from "@/context/CerteroContext";

const ICONS = {
  wrench: Wrench, package: Package, route: Route, pin: MapPin,
  sprout: Sprout, crosshair: Crosshair, grad: GraduationCap,
};

export default function PorQue() {
  const { scrollToId } = useCertero();
  const [big, ...rest] = PORQUE;
  const BigIcon = ICONS[big.icon];

  return (
    <section id="porque" className="scroll-mt-20 bg-ink px-4 py-20 sm:px-8 lg:px-12 lg:py-32">
      <div className="mx-auto max-w-[1400px]">
        <Reveal>
          <SectionTag>Por qué CERTERO</SectionTag>
          <TituloLineas
            lineas={["No vendemos un dron.", "Entregamos una operación completa."]}
            className="mt-5 max-w-3xl font-display text-2xl font-bold uppercase leading-tight tracking-tight text-mist sm:text-3xl lg:text-4xl"
          />
        </Reveal>

        <div className="mt-14 grid grid-cols-1 gap-5 md:grid-cols-8 lg:grid-cols-12">
          {/* Taller — tarjeta principal */}
          <Reveal className="md:col-span-8 lg:col-span-7">
            <div
              data-testid="bento-differentiator-taller"
              className="group relative flex h-full min-h-[320px] flex-col justify-end overflow-hidden border border-hud"
            >
              <img
                src={IMG.taller}
                alt="Sede de CERTERO SRL con el DJI Agras T100 en exhibición y el banner de beneficios de los drones DJI Agras"
                loading="lazy"
                decoding="async"
                className="absolute inset-0 h-full w-full object-cover opacity-50 transition-[opacity,transform] duration-700 group-hover:scale-[1.03] group-hover:opacity-60"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-abyss via-abyss/60 to-transparent" aria-hidden="true" />
              <div className="relative p-7 sm:p-9">
                <BigIcon className="h-6 w-6 text-certero" strokeWidth={1.5} />
                <h3 className="mt-4 font-display text-xl font-bold uppercase tracking-wide text-mist sm:text-2xl">
                  {big.t}
                </h3>
                <p className="mt-2 max-w-md text-sm leading-relaxed text-mist/75">{big.d}</p>
              </div>
            </div>
          </Reveal>

          {rest.map((item, i) => {
            const Icon = ICONS[item.icon];
            const isAcademy = item.id === "academy";
            const wide = item.id === "llave" || item.id === "campo";
            return (
              <Reveal
                key={item.id}
                delay={0.06 * (i + 1)}
                className={`${wide ? "md:col-span-4 lg:col-span-5" : "md:col-span-4 lg:col-span-4"}`}
              >
                <button
                  data-testid={`bento-differentiator-${item.id}`}
                  onClick={() => isAcademy && scrollToId("academy")}
                  className={`group flex h-full flex-col justify-between border border-hud bg-abyss p-7 text-left transition-[border-color,background-color,transform] duration-300 hover:-translate-y-1 hover:border-certero/60 hover:bg-surface sm:p-8 ${isAcademy ? "cursor-pointer" : "cursor-default"}`}
                >
                  <Icon className="h-5 w-5 text-certero" strokeWidth={1.5} />
                  <div className="mt-8">
                    <h3 className="font-display text-base font-bold uppercase tracking-wide text-mist sm:text-lg">
                      {item.t}
                    </h3>
                    <p className="mt-2 text-sm leading-relaxed text-smoke">{item.d}</p>
                    {isAcademy && (
                      <span className="mt-4 inline-block font-mono text-[10px] uppercase tracking-[0.25em] text-certero">
                        Conocer Academy →
                      </span>
                    )}
                  </div>
                </button>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
